import { isMobile } from "@/lib/device"
import { motion } from "@/lib/animations"
import { cn } from "@/lib/utils"
import { Tooltip } from "./Tooltip"
import { tooltipStyles } from "./tooltipStyles"
import {
	MultiGraphTooltipContent,
	MultiGraphTooltipProps,
} from "../../../graphs/types/bar-line/MultiGraphContent"

interface TooltipAdapterProps {
	tooltipData: MultiGraphTooltipProps
	left?: number
	top?: number
}

export const TooltipAdapter = ({
	left,
	top,
	tooltipData,
}: TooltipAdapterProps) => {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{isMobile() ? (
				<div
					style={tooltipStyles}
					className="inset-x-1/2 top-0 z-100 w-1/2 max-w-none min-w-[200px] -translate-x-1/2 opacity-90"
				>
					<MultiGraphTooltipContent {...tooltipData} />
				</div>
			) : (
				<Tooltip
					left={left}
					top={top}
					className={cn(
						"max-width-xs pointer-events-none opacity-90",
					)}
				>
					<MultiGraphTooltipContent {...tooltipData} />
				</Tooltip>
			)}
		</motion.div>
	)
}
